import React, { useState } from "react";
import {
  collection,
  deleteDoc,
  doc,
  addDoc,
  getDocs,
  updateDoc,
} from "firebase/firestore";
import {
  Box,
  Typography,
  Button,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Chip,
} from "@mui/material";
import { firestore } from "../Firebase.js";
import { useAuth } from "./AuthContext";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { styled } from "@mui/material/styles";

import Rating from "@mui/material/Rating";
import MessageIcon from "@mui/icons-material/Message";
import LocalDiningIcon from "@mui/icons-material/LocalDining";
import { useNavigate } from "react-router-dom";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";

const StyledRating = styled(Rating)({
  "& .MuiRating-iconFilled": {
    color: "#9B4F96",
  },
  "& .MuiRating-iconHover": {
    color: "#710193",
  },
});

const PlaceDetails = ({ place }) => {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();
  const handleCreate = async () => {
    const currentDate = new Date();
    const month = currentDate.getMonth() + 1;
    const day = currentDate.getDate();
    const year = currentDate.getFullYear();
    const withSlashes = [month, day, year].join("/");

    const chatsRef = collection(firestore, "chats");
    const data = await getDocs(chatsRef);
    const chats = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
    const chatDoesExist = false;
    chats.forEach((chat) => {
      if (
        (chat.chatter1 === user.name ||
          chat.chatter1 === "Cool Food Shelter" ||
          chat.chatter1 === "Nice Restaurant") &&
        (chat.chatter2 === user.name ||
          chat.chatter2 === "Cool Food Shelter" ||
          chat.chatter2 === "Nice Restaurant")
      ) {
        chatDoesExist = true;
      }
    });

    if (!chatDoesExist) {
      const { id } = await addDoc(collection(firestore, "chats"), {
        chatter1: user.name,
        chatter2: "Cool Food Shelter",
        isNewChat: true,
        date: withSlashes,
      });
      const chatDoc = doc(firestore, "chats", id);
      const newFields = { test: id };
      await updateDoc(chatDoc, newFields);
    }
  };

  const classes = {
    chip: {
      margin: "5px 5px 5px 0",
    },
    subtitle: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginTop: "10px",
    },
    spacing: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
  };
  const [star_rating, setStarRating] = React.useState(2);
  return (
    <Card elevation={6}>
      <CardMedia
        style={{ height: 150 }}
        image={
          place.photo
            ? place.photo.images.large.url
            : "https://catholiccharitiesla.org/wp-content/uploads/2018/05/CC_Photos_HowToHelp_CommunityStats.jpg"
        }
        title={place.name}
      ></CardMedia>
      <CardContent>
        <Box display="flex" justifyContent="space-between">
          <Typography gutterBottom variant="h6" component="legend">
            {place.name}
          </Typography>

          <StyledRating
            name="customized-color"
            defaultValue={3.5}
            getLabelText={(value) => `${value} Heart${value !== 1 ? "s" : ""}`}
            precision={0.5}
            icon={<FavoriteIcon fontSize="inherit" />}
            emptyIcon={<FavoriteBorderIcon fontSize="inherit" />}
            value={star_rating}
            onChange={(event, newValue) => {
              setStarRating(newValue);
            }}
          />
          <MessageIcon
            onClick={() => {
              handleCreate();
              navigate("/chatroom");
            }}
          />
        </Box>
        <Box display="flex" justifyContent="space-between">
          <Typography
            gutterBottom
            variant="body2"
            component="legend"
            color="textSecondary"
          >
            <LocationOnIcon />
            Place Address
            {place.address}
          </Typography>
        </Box>
        <Box display="flex" justifyContent="space-between">
          <Typography
            gutterBottom
            variant="body2"
            component="legend"
            color="textSecondary"
          >
            <LocalDiningIcon />
            Mexian food every Tuesdays and Thursdays from 3-6 pm;
            vegetarian/vegan options available.
            {place.food_desc}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default PlaceDetails;
